export const ReducerTypes = {
  EXITREASONSPOLICY: 'EXITREASONSPOLICY',
};
